var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.325,
    height: 21.693,
    viewBox: "0 0 23.325 21.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_963",
    "data-name": "Tracciato 963",
    d: "M-7420.429,12492.552l14.575,8.545-3.826,9.112",
    transform: "matrix(-0.259, 0.966, -0.966, -0.259, 10168.208, 10406.348)",
    fill: "none",
    stroke: "#5dbfab",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSuccessIcon);
export default __webpack_public_path__ + "static/media/input-success-icon.ba25b811bd5b709a0a26471f33fd86d2.svg";
export { ForwardRef as ReactComponent };